import { useState, useEffect } from 'react'
import { getCanadaTorontoNow, CanadaTorontoNow } from '@/utils/dateTime'

/**
 * Hook to get current time in Canada/Toronto timezone
 * Updates every minute to keep time current
 */
export const useCanadianTime = () => {
  const [canadianTime, setCanadianTime] = useState<CanadaTorontoNow>(() => getCanadaTorontoNow())

  useEffect(() => {
    // Update time every minute
    const interval = setInterval(() => {
      setCanadianTime(getCanadaTorontoNow())
    }, 60000) // 60 seconds

    return () => clearInterval(interval)
  }, [])

  return canadianTime
}

/**
 * Get current Canadian time without hook (for static usage)
 */
export const getCanadianTime = () => getCanadaTorontoNow()
